import React, { useContext, useState, useEffect, useCallback } from 'react'
import { AuthContext } from '@/layout/Auth'
import TransferList from '@/components/TransferList'
import { getPermissions } from '@/api'
import { TreeDataProps } from '@/components/TransferList/treeNode'
import { PermissionInfo, MemberInfo } from '@/types'
import Modal2 from '@/components/Modal2'
import { Stack } from '@mui/material'

interface EditPermissionModalProps {
  value?: number[]
  list?: PermissionInfo[]
  userInfo?: MemberInfo
  open: boolean
  onCancel: () => void
  onOk?: (ids: number[]) => void
}

const EditPermissionModal: React.FC<EditPermissionModalProps> = ({ value, open, onCancel, list: propsList, onOk }) => {
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const [list, setList] = useState<PermissionInfo[]>(propsList ?? [])
  const [checkIds, setCheckIds] = useState<number[]>(value ?? [])
  const dataTransformation = (data: PermissionInfo[]) => {
    const treeData: TreeDataProps[] = []
    for (const item of data) {
      const [parentTitle, childTitle] = item.name.split('-')?.map((item) => item.trim())
      const parentNode: TreeDataProps = {
        id: parentTitle,
        name: parentTitle,
        children: [],
      }
      const childNode = { id: item.id, name: childTitle }
      if (treeData.find((treeNode) => treeNode.id === parentTitle)) {
        const targetNode = treeData.find((treeNode) => treeNode.id === parentTitle)
        targetNode!.children!.push(childNode)
      } else {
        parentNode!.children!.push(childNode)
        treeData.push(parentNode)
      }
    }
    return treeData
  }

  const onSubmit = () => {
    onOk?.(checkIds)
    onCancel()
  }

  useEffect(() => {
    if (open && !propsList) {
      getPermissions({ id: orgInfo?.id!, query: {} }).then((res) => {
        setList(res.data || [])
      })
    }
  }, [open, propsList])

  useEffect(() => {
    setCheckIds(value ?? [])
  }, [value])

  const onChangePerms = useCallback((permIds: number[]) => {
    setCheckIds(permIds)
  }, [])

  useEffect(() => {
    setList(propsList ?? [])
  }, [propsList])

  return (
    <Modal2 title='选择权限' width={1100} open={open} onCancel={onCancel} onOk={onSubmit}>
      <Stack sx={{ height: '70vh' }}>
        <TransferList
          id='id'
          data={list}
          treeView={true}
          treeData={dataTransformation(list)}
          searchKey='name'
          checked={checkIds}
          // @ts-ignore
          onChange={onChangePerms}
        />
      </Stack>
    </Modal2>
  )
}

export default EditPermissionModal
